import { LogHelper } from 'com-gyf-webcore-loghelper';
import { Engine1Proxy } from 'com-gyf-webcore-servicehub';

export const CUENTA_CLIENTE_ACTION_PRUEBA = 'CUENTA_CLIENTE_ACTION_PRUEBA';

export function getScreenData(currentScope) {

    LogHelper.In(getScreenData.name, currentScope);

    return (dispatch, getState) => {

        let state = getState();
        let data = {};
        dispatch({ type: CUENTA_CLIENTE_ACTION_PRUEBA, data });
    };
};